import Vue from "vue";
import Router from "vue-router";
import messagesRouter from "./messages";
import cyclesRouter from "./cycles";
import payehRouter from "./payeh";
import hozoorRouter from "./hozoor";
import khoroojRouter from "./khorooj";
import transfersRouter from "./transfers";
import salaryRouter from "./salary";
import homeRequestRouter from "./home-request";
import sabtenamRouter from "./sabtenam";
import linksRouter from "./links";
import ertebatRouter from "./ertebat";
import madrakRouter from "./madrak";
import maritalRouter from "./marital";
import morkhasiRouter from "./morkhasi";
import tahsilRouter from "./tahsil";
import tadrisRouter from "./tadris";
import permissionRouter from "./tadris-permission";
import deleteRouter from "./delete-course";
import pictureRouter from "./picture";
import resumeRouter from "./resume";
import eterazRouter from "./eteraz";
import shafahiRouter from "./shafahi";
import pollRouter from "./poll";
import discussionRouter from "./discussion";
import talabbosRouter from "./talabbos";
import aboutusRouter from "./aboutus";
import jazbRouter from "./jazb";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    ...messagesRouter,
    ...cyclesRouter,
    ...payehRouter,
    ...hozoorRouter,
    ...khoroojRouter,
    ...transfersRouter,
    ...salaryRouter,
    ...homeRequestRouter,
    ...sabtenamRouter,
    ...linksRouter,
    ...ertebatRouter,
    ...madrakRouter,
    ...maritalRouter,
    ...tadrisRouter,
    ...morkhasiRouter,
    ...tahsilRouter,
    ...permissionRouter,
    ...deleteRouter,
    ...pictureRouter,
    ...resumeRouter,
    ...eterazRouter,
    ...shafahiRouter,
    ...pollRouter,
    ...discussionRouter,
    ...aboutusRouter,
    ...talabbosRouter,
    ...jazbRouter,
    {
      path: "/",
      name: "Home",
      component: () => import("@/views/home/Home.vue"),
    },
    {
      path: "/index",
      name: "Index",
      component: () => import("@/views/home/Index.vue"),
    },
    {
      path: "/info",
      name: "Info",
      component: () => import("@/views/home/Info.vue"),
    },
    {
      path: "/loginWithOpenID",
      name: "OpenID",
      component: () => import("@/views/login/loginWithOpenID"),
      hidden: true,
    },
    {
      path: "/contactus",
      name: "ContactUs",
      component: () => import("@/views/home/ContactUs.vue"),
      meta: { title: "ارتباط با ما" },
    },
  ],
});

export default router;
